import React from 'react';
import { InputLabelComponent } from '../components/input-label.component'

export function InputLabelContainer ({ id, label, isRequired, className }: any) {
  return (<InputLabelComponent
      className={className}
      id={id}
      isRequired={isRequired}
      label={label}
          />)
}
